import React, { forwardRef, useId } from 'react';
import { Icon } from '../../design/Icon';

export function Field({ label, hint, error, htmlFor, className = '', children }) {
  return (
    <div className={`field ${className}`.trim()}>
      {label && (
        <label className="label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {hint && !error && <span className="hint">{hint}</span>}
      {error && (
        <span className="field-error" role="alert">
          <Icon name="alert" className="ico-sm" />
          <span>{error}</span>
        </span>
      )}
    </div>
  );
}

export const Input = forwardRef(function Input({ invalid = false, className = '', ...rest }, ref) {
  return <input ref={ref} className={['input', invalid ? 'invalid' : '', className].filter(Boolean).join(' ')} aria-invalid={invalid || undefined} {...rest} />;
});

export const Select = forwardRef(function Select({ className = '', children, ...rest }, ref) {
  return (
    <select ref={ref} className={`select ${className}`.trim()} {...rest}>
      {children}
    </select>
  );
});

export const Textarea = forwardRef(function Textarea({ className = '', rows = 3, ...rest }, ref) {
  return <textarea ref={ref} rows={rows} className={`textarea ${className}`.trim()} {...rest} />;
});

export function Check({ label, className = '', ...rest }) {
  return (
    <label className={`check ${className}`.trim()}>
      <input type="checkbox" {...rest} />
      <span>{label}</span>
    </label>
  );
}

export function Switch({ label, className = '', ...rest }) {
  return (
    <label className={`switch ${className}`.trim()}>
      <input type="checkbox" role="switch" {...rest} />
      {label && <span>{label}</span>}
    </label>
  );
}

export function FormGrid({ children }) {
  return <div className="form-grid">{children}</div>;
}

export function useFieldId(prefix = 'f') {
  return `${prefix}-${useId().replace(/:/g, '')}`;
}
